export class AccessCard {
  id: number;
  companyId: number;
  companyName: string;
  holderId: number;
  holderName: string;
  accessCardTypeId: number;
  accessCardTypeName: string;
  badgeNumber: string;
  startDate: Date;
  endDate: Date;
  isActive: boolean;
  isCollected: string;
  isDriverCard: boolean;
  requestId: number;
  statusName: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/access-card.ts